export const mainColors = [
  { label: "ブラック", value: "ブラック", isColor: true },
  { label: "ネイビー", value: "ネイビー", isColor: true },
  { label: "ブルー", value: "ブルー", isColor: true },
  { label: "サックス", value: "サックス", isColor: true },
  { label: "オレンジ", value: "オレンジ", isColor: true },
  { label: "Dオレンジ", value: "Dオレンジ", isColor: true },
  { label: "レッド", value: "レッド", isColor: true },
  { label: "ピンク", value: "ピンク", isColor: true },
  { label: "パープル", value: "パープル", isColor: true },
  { label: "レモン", value: "レモン", isColor: true },
  { label: "コルク", value: "コルク", isColor: true },
  { label: "チョコ", value: "チョコ", isColor: true },
  { label: "グリーン", value: "グリーン", isColor: true },
  { label: "Mグリーン", value: "Mグリーン", isColor: true },
  { label: "グレー", value: "グレー", isColor: true },
  { label: "ホワイト", value: "ホワイト", isColor: true },
  { label: "キャメル", value: "キャメル", isColor: true },
  { label: "シルバー", value: "シルバー", isColor: true },
  { label: "ゴールド", value: "ゴールド", isColor: true },
];

export const generateColorOptions = (partName) => {
  return mainColors.map((color) => ({
    label: color.label, // ドロップダウンに表示させたい文字
    value: color.value, // 選択したときの識別用
    part: partName, // 部位（親指外側とか）
    isColor: color.isColor || false, // mainColorsのisColorを引き継ぐ
  }));
};

export const mainColorOptions = generateColorOptions("本体");
export const thumbOutOptions = generateColorOptions("親指外側");
export const thumbInOptions = generateColorOptions("親指内側");
export const indexFingerOutOptions = generateColorOptions("人差し指外側");
export const indexFingerInOptions = generateColorOptions("人差し指内側");
export const middleFingerOutOptions = generateColorOptions("中指外側");
export const middleFingerInOptions = generateColorOptions("中指内側");
export const thirdFingerOutOptions = generateColorOptions("薬指外側");
export const thirdFingerInOptions = generateColorOptions("薬指内側");
export const littleFingerOutOptions = generateColorOptions("小指外側");
export const littleFingerInOptions = generateColorOptions("小指内側");
export const bandColorOptions = generateColorOptions("バンド");
export const catchColorOptions = generateColorOptions("捕球面");
export const thumbHangerOptions = generateColorOptions("親指掛け");
export const littleFingerHangerOptions = generateColorOptions("小指掛け");
export const hemLeatherOptions = generateColorOptions("ヘリ革");
export const webBackOptions = generateColorOptions("ウェブ背面側・タテ棒");
export const webCatchOptions = generateColorOptions("ウェブ捕球面側・ヨコ棒");
export const webEdgeOptions = generateColorOptions("ウェブエッジ・その他");
export const hirauraOptions = generateColorOptions("平裏");
export const treasureBeltOptions = generateColorOptions("トレジャーベルト");
export const fingerCoverColorOptions = generateColorOptions("指カバー・指あて");
  // 王冠用
  export const indexAndMiddleFingerOptions = generateColorOptions("人差し指 外側・中指 内側");
  export const middleAndThirdFingerOptions = generateColorOptions("中指 外側・薬指 内側");
  export const thirdAndLittleFingerOptions = generateColorOptions("薬指 外側・小指 内側");
  // ライナーバック用
  export const thumbIndexAndMiddleFingerOptions = generateColorOptions("親指 内側・人差し指・中指 内側");
  export const linerBackBeltColorOptions = generateColorOptions("ライナーバックベルト")

export const hamidashiAdditionalOptions = {
  切はみ: [
    { label: "ホワイト", value: "ホワイト", isColor: true },
    { label: "ブラック", value: "ブラック", isColor: true },
  ],
  玉はみ: [
    { label: "ブラック", value: "ブラック", isColor: true },
    { label: "ネイビー", value: "ネイビー", isColor: true },
    { label: "ブルー", value: "ブルー", isColor: true },
    { label: "サックス", value: "サックス", isColor: true },
    { label: "オレンジ", value: "オレンジ", isColor: true },
    { label: "Dオレンジ", value: "Dオレンジ", isColor: true },
    { label: "レッド", value: "レッド", isColor: true },
    { label: "ピンク", value: "ピンク", isColor: true },
    { label: "パープル", value: "パープル", isColor: true },
    { label: "レモン", value: "レモン", isColor: true },
    { label: "コルク", value: "コルク", isColor: true },
    { label: "チョコ", value: "チョコ", isColor: true },
    { label: "グリーン", value: "グリーン", isColor: true },
    { label: "Mグリーン", value: "Mグリーン", isColor: true },
    { label: "グレー", value: "グレー", isColor: true },
    { label: "ホワイト", value: "ホワイト", isColor: true },
    { label: "キャメル", value: "キャメル", isColor: true },
    { label: "シルバー", value: "シルバー", isColor: true },
    { label: "ゴールド", value: "ゴールド", isColor: true },
  ],
};

export const laceColorOptions = [
  { label: "ブラック", value: "ブラック", isColor: true },
  { label: "中白ブラック", value: "中白ブラック", isColor: true },
  { label: "ネイビー", value: "ネイビー", isColor: true },
  { label: "ブルー", value: "ブルー", isColor: true },
  { label: "ミズイロ", value: "ミズイロ", isColor: true },
  { label: "オレンジ", value: "オレンジ", isColor: true },
  { label: "Dオレンジ", value: "Dオレンジ", isColor: true },
  { label: "レッド", value: "レッド", isColor: true },
  { label: "ピンク", value: "ピンク", isColor: true },
  { label: "中白パープル", value: "中白パープル", isColor: true },
  { label: "レモン", value: "レモン", isColor: true },
  { label: "コルク", value: "コルク", isColor: true },
  { label: "チョコ", value: "チョコ", isColor: true },
  { label: "中白チョコ", value: "中白チョコ", isColor: true },
  { label: "グリーン", value: "グリーン", isColor: true },
  { label: "グレー", value: "グレー", isColor: true },
  { label: "ホワイト", value: "ホワイト", isColor: true },
  { label: "キャメル", value: "キャメル", isColor: true },
];

export const stitchColorOptions = [
  { label: "ブラック", value: "ブラック", isColor: true },
  { label: "ネイビー", value: "ネイビー", isColor: true },
  { label: "ブルー", value: "ブルー", isColor: true },
  { label: "サックス", value: "サックス", isColor: true },
  { label: "オレンジ", value: "オレンジ", isColor: true },
  { label: "レッド", value: "レッド", isColor: true },
  { label: "ピンク", value: "ピンク", isColor: true },
  { label: "パープル", value: "パープル", isColor: true },
  { label: "イエロー", value: "イエロー", isColor: true },
  { label: "コルク", value: "コルク", isColor: true },
  { label: "グリーン", value: "グリーン", isColor: true },
  { label: "ホワイト", value: "ホワイト", isColor: true },
  { label: "キャメル", value: "キャメル", isColor: true },
  { label: "Lシルバー", value: "Lシルバー", isColor: true },
  { label: "Lゴールド", value: "Lゴールド", isColor: true },
];

export const treasureLabelOptions = [
  { label: "標準1(ゴールド×レッド×ブラック)", value: "ラベル選択1", cost: 0 },
  {
    label: "標準2(ゴールド×ブラック×Lゴールド)",
    value: "ラベル選択2",
    cost: 0,
  },
  {
    label: "オリジナル（+3,300円&納期+30日）",
    value: "オリジナル",
    cost: 3000,
  },
];

export const orderMadeMainColors = [
  { label: "ブラック", value: "ブラック", isColor: true },
  { label: "ネイビー", value: "ネイビー", isColor: true },
  { label: "ブルー", value: "ブルー", isColor: true },
  { label: "サックス", value: "サックス", isColor: true },
  { label: "オレンジ", value: "オレンジ", isColor: true },
  { label: "レッド", value: "レッド", isColor: true },
  { label: "Rピンク", value: "Rピンク", isColor: true },
  { label: "Sピンク", value: "Sピンク", isColor: true },
  { label: "パープル", value: "パープル", isColor: true },
  { label: "イエロー", value: "イエロー", isColor: true },
  { label: "Lイエロー", value: "Lイエロー", isColor: true },
  { label: "コルク", value: "コルク", isColor: true },
  { label: "チョコ", value: "チョコ", isColor: true },
  { label: "グリーン", value: "グリーン", isColor: true },
  { label: "Lグリーン", value: "Lグリーン", isColor: true },
  { label: "ホワイト", value: "ホワイト", isColor: true },
  { label: "キャメル", value: "キャメル", isColor: true },
  { label: "Lシルバー", value: "Lシルバー", isColor: true },
  { label: "Lゴールド", value: "Lゴールド", isColor: true },
  { label: "銀糸", value: "銀糸", isColor: true },
  { label: "金糸", value: "金糸", isColor: true },
];

export const orderMadeColorOptions = (partName) => {
  return orderMadeMainColors.map((color) => ({
    label: color.label, // ドロップダウンに表示させたい文字
    value: color.value, // 選択したときの識別用
    part: partName, // 部位（親指外側とか）
    isColor: color.isColor || false, // mainColorsのisColorを引き継ぐ
  }));
};

export const optionMainColorOptions = orderMadeColorOptions("メインカラー");
export const optionShadowColorOptions = orderMadeColorOptions("カゲカラー");

export const optionStandColorOptions = [
  { label: "ブラック", value: "ブラック", isColor: true },
  { label: "ネイビー", value: "ネイビー", isColor: true },
  { label: "ブルー", value: "ブルー", isColor: true },
  { label: "サックス", value: "サックス", isColor: true },
  { label: "オレンジ", value: "オレンジ", isColor: true },
  { label: "レッド", value: "レッド", isColor: true },
  { label: "エンジ", value: "エンジ", isColor: true },
  { label: "Sピンク", value: "Sピンク", isColor: true },
  { label: "パープル", value: "パープル", isColor: true },
  { label: "イエロー", value: "イエロー", isColor: true },
  { label: "グリーン", value: "グリーン", isColor: true },
  { label: "ホワイト", value: "ホワイト", isColor: true },
  { label: "Lシルバー", value: "Lシルバー", isColor: true },
  { label: "Lゴールド", value: "Lゴールド", isColor: true },
];